<template>
  <div class="monopoly" :style="{backgroundImage:`url(${JSON.parse(marketingActivityData.activity.templePage).drawPage.monopoly.background.pictureUrl})`}">

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('market', ['marketingActivityData'])
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
.monopoly{
  height: 682px;
  background-size: 100% 100%;
}
</style>
